import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LcpPreloaderService {
  private renderer: Renderer2;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  addPreloadLink(
    link: string,
    elementType = 'image',
    rel = 'preload',
    fetchpriority = 'high',
    type = 'image/webp'
  ) {
    const linkElement = this.renderer.createElement('link');
    linkElement.rel = rel;
    this.renderer.setAttribute(linkElement, 'as', elementType);
    linkElement.href = link;
    linkElement.type = type;
    this.renderer.setAttribute(linkElement, 'fetchpriority', fetchpriority);
    this.renderer.appendChild(this.document.head, linkElement);
  }
}
